import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Mail, Phone } from "lucide-react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen" data-testid="terms-page">
      <Header />
      
      <section className="pt-24 pb-16 bg-gradient-to-b from-primary/10 to-background">
        <div className="container text-center">
          <h1 className="text-4xl md:text-5xl font-serif text-primary mb-4 font-bold">Terms and Conditions</h1>
          <p className="text-lg text-foreground/70 max-w-2xl mx-auto font-medium">
            Please read these terms carefully before using our services
          </p>
        </div>
      </section>

      <section className="py-12 bg-background">
        <div className="container max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground mb-4">
              Welcome to Siwon Galaxy / Siwon Harmony. By using our website, services, or digital products, you agree to these Terms and Conditions.
            </p>
            <div className="mb-8 p-4 bg-primary/5 border-l-4 border-primary rounded-r-lg">
              <p className="text-sm text-foreground/80 m-0">
                <span className="font-semibold text-foreground">Operated by:</span> Siwon Health Care Resources Pvt. Ltd.<br />
                <span className="font-semibold text-foreground">Registered Address:</span> H.No. 330-B, Mianwali Colony, Gurgaon - 122001, Haryana, India<br />
                <span className="font-semibold text-foreground">CIN:</span> U85110HR2003PTC069710 &nbsp;·&nbsp; <span className="font-semibold text-foreground">GSTIN:</span> 06AAHCS1570M1Z3
              </p>
            </div>

            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">1. Services</h2>
                <p className="text-foreground/80 leading-relaxed">
                  We provide coaching, consulting, digital services, educational content, and web application access as described on the website. Our services include relationship coaching, life transformation coaching, the Siwon Harmony App, membership programs, webinars, and related digital offerings.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">2. Eligibility</h2>
                <p className="text-foreground/80 leading-relaxed">
                  You must be at least 18 years old to use our services, or have parental/guardian consent where applicable.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">3. Payments</h2>
                <p className="text-foreground/80 leading-relaxed">
                  All payments are processed securely through third-party payment gateways such as Razorpay. Prices are displayed in INR (Indian Rupees) unless stated otherwise. All applicable taxes including GST will be added as per government regulations.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">4. Service Delivery</h2>
                <p className="text-foreground/80 leading-relaxed">
                  Our services are delivered digitally through online sessions, email, dashboard access, downloadable resources, video calls, webinars, or other stated methods. Access to digital services is typically provided within 24 hours of successful payment.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">5. User Responsibilities</h2>
                <p className="text-foreground/80 leading-relaxed">
                  You agree to provide accurate information and not misuse the website or services. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">6. Intellectual Property</h2>
                <p className="text-foreground/80 leading-relaxed">
                  All content, frameworks, designs, text, videos, tools, methodologies (including the SIWON methodology, Five Koshas framework), and materials on this website remain the property of Siwon Galaxy unless otherwise stated. Unauthorized reproduction, distribution, or use is prohibited.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">7. Limitation of Liability</h2>
                <p className="text-foreground/80 leading-relaxed">
                  We are not liable for indirect, incidental, or consequential losses arising from the use of our services or website. Our coaching and consulting services are for educational and personal development purposes and do not constitute professional medical, legal, or financial advice.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">8. Changes to Terms</h2>
                <p className="text-foreground/80 leading-relaxed">
                  We may update these Terms and Conditions at any time. Continued use of the website means acceptance of the updated terms. We recommend reviewing this page periodically for any changes.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">9. Governing Law</h2>
                <p className="text-foreground/80 leading-relaxed">
                  These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Gurgaon, Haryana, India.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-serif font-bold text-primary mb-3">10. Contact</h2>
                <p className="text-foreground/80 leading-relaxed mb-4">
                  For questions regarding these Terms and Conditions, please contact us:
                </p>
                <div className="bg-muted/50 rounded-lg p-6 space-y-3">
                  <div className="flex items-center gap-3">
                    <Mail className="w-5 h-5 text-primary" />
                    <a href="mailto:siwongalaxy108@gmail.com" className="text-primary hover:text-primary/80">
                      siwongalaxy108@gmail.com
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Phone className="w-5 h-5 text-primary" />
                    <a href="tel:+917042106100" className="text-primary hover:text-primary/80">
                      +91 7042106100
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-sm text-muted-foreground mt-12 pt-6 border-t border-border">
              Last updated: December 2025
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
